import { tone } from '../lib/types';

/**
 * Striped tinted placeholder block, or a real image when `src` is provided.
 * `i` cycles the tint (t1–t6); `label` is the centered monospace caption.
 */
export function Placeholder({
  i = 0,
  label = 'product shot',
  src,
  alt,
  className = '',
}: {
  i?: number;
  label?: string;
  src?: string | null;
  alt?: string;
  className?: string;
}) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt ?? label}
        loading="lazy"
        className={`h-full w-full object-cover ${className}`}
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).style.display = 'none';
        }}
      />
    );
  }
  return (
    <div className={`ph ${tone(i)} ${className}`}>
      <span>{label}</span>
    </div>
  );
}
